import { Routes } from "@angular/router";
import { WidgetComponent } from "./features/widget/widget.component";
import { ErrorComponent } from "./features/error/error.component";
import { DonationComponent } from "./features/donation/donation.component";
import { SaleComponent } from "./features/sales/sale.component";
import { GoalComponent } from "./features/goal/goal.component";
import { RhynothonComponent } from "./features/rhynothon/rhynothon.component";
import { MusicthonComponent } from "./features/musicthon/musicthon.component";

export const routes: Routes = [
  {
    component: WidgetComponent,
    path: "widget/:atname/:type",
  },
  {
    component: DonationComponent,
    path: "donations/:id",
    data: { watchMode: false },
  },
  {
    component: DonationComponent,
    path: "donations/:id/watch",
    data: { watchMode: true },
  },
  {
    component: SaleComponent,
    path: "sales/:id",
    data: { watchMode: false },
  },
  {
    component: SaleComponent,
    path: "sales/:id/watch",
    data: { watchMode: true },
  },
  {
    component: GoalComponent,
    path: "goals/:id",
  },
  {
    component: RhynothonComponent,
    path: "rhynothon/:id",
  },
  {
    component: MusicthonComponent,
    path: "musicthon/:id",
  },
  {
    component: ErrorComponent,
    path: "error",
  },
  { path: "", redirectTo: "/error", pathMatch: "full" },
  { path: "**", redirectTo: "/error" },
];
